export const FIXED_POSTER_VIEW_WIDTH_PX = 94;
export const FIXED_META_INFO_BOX_HEIGHT_PX = 68;
export const FIXED_META_INFO_RATIO =
  FIXED_META_INFO_BOX_HEIGHT_PX / FIXED_POSTER_VIEW_WIDTH_PX;
